import {Component, OnInit} from '@angular/core';
import {BasketService} from "../../../shared/services/basket.service";
import {ActivatedRoute} from "@angular/router";
import {BasketOrder} from "../../../shared/models/basket-order";
import {CustomSnackbarService} from "../../../shared/services/custom.snackbar.service";
import {SnackbarTypeError} from "../../../shared/msg-snackbar/msg-snackbar.component";
import {ImageService} from "../../../shared/services/image.service";
import {ArticleService} from "../../../shared/services/article.service";

@Component({
    selector: 'app-order-success',
    templateUrl: './success.component.html',
    styleUrls: ['./success.component.scss'],
    providers: [BasketService, ImageService, CustomSnackbarService, ArticleService],
    standalone: false
})
export class SuccessComponent implements OnInit {
    basketOrder: BasketOrder;
    totalOrder: number;
    loading: boolean;

    constructor(
        private basketService: BasketService,
        private customSnackbarService: CustomSnackbarService,
        private route: ActivatedRoute,
        private uploadFileService: ImageService,
        public articleService: ArticleService
    ) {
        this.loading = true;
        this.totalOrder = 0;
    }

    ngOnInit() {
        this.route.params.subscribe(params => {
            const id = params['id'];
            this.getOrder(id)
        });
    }

    getOrder(id) {
        this.basketService.get(id).subscribe(
            res => {
                this.basketOrder = JSON.parse(res.body);
                this.basketOrder.items.forEach(basketItem => {
                    this.totalOrder += (this.articleService.getPriceToShow(basketItem.unitPrice) * basketItem.quantity)
                });
                this.loading = false;
            },
            error => {
                this.customSnackbarService.open('Ha ocurrido un error', SnackbarTypeError.ERROR);
            }
        )
    }
    getUrl = (photos: string) => {
        return this.uploadFileService.getUrlFirstElement(photos);
    }
}
